import React from 'react';
import { Typography } from '@mui/material';
import ButtonGlynt from './Buttons/ButtonGlynt';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

type Props = {
  total: number;
  page: number;
  previousPage: () => void;
  nextPage: () => void;
};
function PaginationNav({ total, page, previousPage, nextPage }: Props) {
  if (total <= 1) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <ButtonGlynt
        id="prev-button"
        variant="outlined"
        size="small"
        disabled={page === 0}
        onClick={() => previousPage()}
      >
        <KeyboardArrowLeft />
        Previous
      </ButtonGlynt>
      <Typography variant="subtitle1">
        {page + 1} of {total}
      </Typography>
      <ButtonGlynt
        id="next-button"
        variant="outlined"
        size="small"
        disabled={page === total - 1}
        onClick={() => nextPage()}
      >
        Next
        <KeyboardArrowRight />
      </ButtonGlynt>
    </div>
  );
}

export default PaginationNav;
